import {
    ERROR,
    GET_INSURANCE_PREMIUM_PAID_LOANS,
    GET_REPAYMENT_SCHEDULE,
    GET_SINGLE_TRANCHE,
    GET_TRANCHES,
    GET_USER_ALL_TRANCHES,
    LOADER,
    SET_CURRENT_TRANCHE_ID,
} from "../actionType";

let initialState = {
    loading: false,
    error: null,
    // tranches: [],
    tranches: {},
    singleTranche: null,
    currentTrancheId: null,
    repaymentSchedule: [],
    // insurancePremiumPaidLoans: []
    insurancePremiumPaidLoans: {},
    userTranches: {}
};

export const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case LOADER:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case ERROR:
            return {
                ...state,
                loading: false,
                error: payload,
            };
        case GET_SINGLE_TRANCHE:
            return {
                ...state,
                loading: false,
                singleTranche: payload,
                error: null,
            };
        case GET_TRANCHES:
            return {
                ...state,
                loading: false,
                tranches: { data: [...payload.tranches], pagination: payload.pagination },
                error: null,
            };
        case SET_CURRENT_TRANCHE_ID:
            return {
                ...state,
                currentTrancheId: payload,
                singleTranche: state.currentTrancheId !== payload ? null : state.singleTranche,
                repaymentSchedule: state.currentTrancheId !== payload ? [] : state.repaymentSchedule,
            };
        case GET_REPAYMENT_SCHEDULE:
            return { ...state, loading: false, repaymentSchedule: payload, error: null };
        case GET_INSURANCE_PREMIUM_PAID_LOANS:
            return {
                ...state,
                loading: false,
                // insurancePremiumPaidLoans: { data: [...payload.data], pagination: payload.pagination },
                insurancePremiumPaidLoans: { data: [...payload.records], pagination: payload.pagination },
                error: null,
            };
        case GET_USER_ALL_TRANCHES:
            return {
                ...state,
                loading: false,
                userTranches: { data: [...payload.tranches], pagination: payload.pagination },
                error: null,
            };
        default:
            return state;
    }
};